import { MILLISECONDS_PER_SECOND } from 'constants/date';

export const PHONE_VERIFICATION_TEXT =
  "To verify your phone number and double check you're human, we've sent a 6-digit code to your phone number. It might take a minute to receive the code. Enter it below once you get it.";

export const THANK_YOU_VERIFIED_TEXT = 'Thanks for verifying your phone number.';

export const RESEND_CODE_RETRY_MS = 30 * MILLISECONDS_PER_SECOND;
